import { render, staticRenderFns } from "./collectionItemForm.vue?vue&type=template&id=d712fecc&"
import script from "./collectionItemForm.vue?vue&type=script&lang=js&"
export * from "./collectionItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports